interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
  showText?: boolean;
}

export default function Logo({ className = "", width = 44, height = 44, showText = false }: LogoProps) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src="https://storage.readdy-site.link/project_files/42311683-92d4-464a-8a3a-41a67ff77a40/d3f455aa-2a6e-4bd4-a39a-0623a204248e_logo.png?v=51d8e1ed0ea08c5d4fd8ff6dcf3a276d"
        alt="NIMAS Dirang logo"
        width={width}
        height={height}
        className="inline-block object-contain rounded-full"
        style={{ width: `${width}px`, height: `${height}px` }}
      />
      {showText && (
        <span className="font-bold text-gray-900 text-base tracking-wide whitespace-nowrap font-heading">
          NIMAS Dirang
        </span>
      )}
    </div>
  );
}